// @mui material components
import Grid from "@mui/material/Grid";
import { IonButton, IonContent, IonInput, IonItem, IonLabel, IonPage, IonSelect, option , IonLoading} from '@ionic/react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard React compone
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Card from "@mui/material/Card";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Icon from "@mui/material/Icon";
import { FileUploader } from "react-drag-drop-files";
import axios from "axios";
import 'tui-image-editor/dist/tui-image-editor.css';
import FilerobotImageEditor, { TABS, TOOLS} from 'react-filerobot-image-editor';
import {PDFtoIMG} from 'react-pdf-to-image';
import { Auth } from "aws-amplify";

import {
  ProjectsUpcoming,
  ProjectsPast,
} from "layouts/dashboard/components/Projects/indexAdminUpcoming";
import { useEffect, useState, createRef } from "react";
import Table from "examples/Tables/Table";

function Billing() {
  const [display, setDisplay] = useState(false);
  const [uploadCert, setUploadCert] = useState(false);
  const [Filename,setfilename] = useState()
  const [rows,setrows] = useState([])
  const [date1,setdate] = useState(new Date().getDate())
  const [name,setname] = useState("")
  const [reglink, setreglink] = useState("")
  const [x, setx] = useState(0)
  const [y, sety] = useState(0)
  // const [name, setName] = useState("test")
  const [cat, setcat] = useState("")
  const [R, setR] = useState(0)
  const [G, setG] = useState(0)
  const [B, setB] = useState(0)
  const [size, setSize] = useState(30)
  const [pdfinfo, setPdfInfo] = useState()
  const [pdf, setpdf] = useState()
  const [load,setload] = useState(false)

  const [loc,setloc] = useState("")
  const [tenant,settenant] = useState("")

  //modifiedSAAS
  useEffect(()=>{
    Auth.currentUserInfo().then(value=>{
      if(value.username == 'admin' ){
        
        settenant("admin")
      }
      else{
          console.log(value.attributes["custom:company"]);
          settenant(value.attributes["custom:company"])
    
      }
    })
  },[])

  const row = async () => {
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/getCert",{event:name}).then(value=>{
      const rows1 = [];
      value.data.map((certs) =>
        rows1.push({
          Name: [certs.id],
          Category: [certs.Category],
          Edit: <SuiButton variant="outlined" color="info" size="small" onClick={()=>{setfilename(certs.id)}}>Edit</SuiButton>,
          Delete: <SuiButton variant="outlined" color="info" size="small" onClick={()=>{deletecert(certs.id)}}>Delete</SuiButton>
        })
      );
      setrows(rows1)
      
    })
  }

  useEffect(()=>{
 

    row()
  },[])

  useEffect(()=>{
    modifyPdf()
  },[Filename])

  const columns = [
    { name: "Name", align: "left" },
    { name: "Category", align: "left" },
    { name: "Edit", align: "center" },
    { name: "Delete", align: "center" },
  ];

  async function deletecert(certname){
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/removeCert",{id:certname}).then(value=>{
      row();
    })
  }

  //modifiedSAAS
  async function addevent(){
    await axios.post("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddEvents", {
      
    name:name,
    date:date1,
    location:loc,
    registrationlink:reglink,
    tenant:tenant
    
  }).then(value=>{
      alert("Event Added")
      window.location.reload();
    })
}

  async function createcertdetails(){
    await axios.get("https://v8hwtb6p43.execute-api.ap-southeast-1.amazonaws.com/default/AddCert?filename="+ Filename + "&cat="+ cat + "&x="+ x + "&y=" + y +"&fontsize="+size+"&eventname="+name).then(value=>{
      alert("Certificate Added")
      row()
    })
}



useEffect(() => {
  modifyPdf(Filename)
}, [x, y, R, G, B, size])

async function modifyPdf(file) {
  const existingPdfBytes = await fetch("https://certificatesys.s3.ap-southeast-1.amazonaws.com/"+file).then(res => res.arrayBuffer()).catch(err=>{console.log(err)})
  const pdfDoc = await PDFDocument.load(existingPdfBytes)
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
  const pages = pdfDoc.getPages()
  const firstPage = pages[0]
  const { width, height } = firstPage.getSize()
  firstPage.drawText("Sample Name", {
    x: width / 2 + parseInt(x),
    y: height / 2 + parseInt(y),
    size: parseInt(size),
    font: helveticaFont,
    color: rgb(parseFloat(R), parseFloat(G), parseFloat(B)),
  })
  // Serialize the PDFDocument to bytes (a Uint8Array)
  const pdfBytes = await pdfDoc.save()
  const bytes = new Uint8Array(pdfBytes);
  const blob = new Blob([bytes], { type: "application/pdf" });
  const docUrl = URL.createObjectURL(blob);
  setPdfInfo(docUrl);
}

  async function uploadfile(file) {
    
    setload(true)

    await  axios.get("https://hlsw9m3hud.execute-api.ap-southeast-1.amazonaws.com/default/uploadfile?filename="+file.name+"&bucket=certificatesys").then(async (value)=>{
         //Create the FormData
         //Send the file to File-system
  console.log("Sending file to S3...");
  

  await axios.put(value.data, file, {
    
    headers: {
        'Content-Type': 'application/pdf',
    
    }

 
}).then( value => {
  alert("success")
  setload(false)
  modifyPdf(file.name)
  setx(0)
  sety(0)


}).catch (error=> {
   console.log(error)
 })
 

  
}).catch(error =>{
  console.log(error)
})     
    }

  const handleChange = async (file) => {
    setfilename(file.name)
    uploadfile(file);
    // setimgfile("https://certificatesys.s3.ap-southeast-1.amazonaws.com/"+e.name)
    // var path = (window.URL || window.webkitURL).createObjectURL(file);
    // console.log(path)
  //     const existingPdfBytes = await fetch(e).then(res => res.arrayBuffer())
  // const pdfDoc = await PDFDocument.load(existingPdfBytes)
  // console.log(pdfDoc);
  // const pages = pdfDoc.getPages()
  // const firstPage = pages[0]

  // console.log(pages)
    // setPdfInfo(e)
  };

  return (
    
    <DashboardLayout>
      <DashboardNavbar />
      <IonLoading isOpen={load} message={"Hang on, opening Certificate Editor"}/>
      <SuiBox mt={4}>
        <SuiBox mb={1.5}>
          <Grid container spacing={12}>
            <Grid item xs={12} lg={12}>
              <Grid container spacing={12}>
                <Grid item xs={12}>
                  <SuiButton variant="gradient" color="dark" onClick={() => setDisplay(!display)}>
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp;Add New Event
                  </SuiButton>
                  <br />
                  <br/>
                  <Card mt={4}>
                    <SuiBox
                      // component="form"
                      // role="form"
                      // bgColor="light"
                      // borderRadius="lg"
                      // shadow="lg"
                      // opacity={1}
                      p={3}
                      // ml={12}
                      // mr={12}
                      style={{ display: display === false ? "none" : "" }}
                    >
                      <SuiTypography component="label" fontWeight="bold">
                        New Event Details
                      </SuiTypography>
                      <SuiBox mb={2}>
                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Name
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Name" onChange={(e)=>{setname(e.target.value)}}/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Location
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Location" onChange={(e)=>{setloc(e.target.value)}}/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Website
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="text" placeholder="Link" onChange={(e)=>{setreglink(e.target.value)}}/>

                        <SuiBox mb={1} ml={0.5}>
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Event Date
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput type="date" placeholder="Date" onChange={(e)=>{setdate(e.target.value)}} />
                      </SuiBox>

                      <SuiBox mt={4} mb={1}>
                        <SuiButton
                          color="dark"
                          variant="gradient"
                          onClick={() => setUploadCert(!uploadCert)}
                        >
                          Add Event Certificate
                        </SuiButton>
                      </SuiBox>
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        style={{ display: uploadCert === false ? "none" : "" }}
                      >
                          
                      <FileUploader handleChange={handleChange} types={['pdf']} />
                      </SuiTypography>
                      <br/>
                      <div>
                        <SuiButton onClick={row} style={{float:"right"}} variant="gradient" color="dark">                    
                        <Icon sx={{ fontWeight: "bold" }}>refresh</Icon>
                        </SuiButton>
                        <br/>
                        <Table columns={columns} rows={rows} />
                      </div>

                      {/* <FilerobotImageEditor
                  source={imgfile}
                  onSave={(e) => console.log(e)}
                  Text={{ text: 'Text' }}
                  tabsIds={[TABS.ANNOTATE]} // or {['Adjust', 'Annotate', 'Watermark']}
                  defaultTabId={TABS.ANNOTATE} // or 'Annotate'
                  defaultToolId={TOOLS.TEXT} // or 'Text'
/> */}

                      <div style={{ width: "25%", float: "right", marginTop: "5%",marginRight: "5%"}}>
          <h1>Cetificate Details</h1>
          <IonItem>
              <IonLabel>Category</IonLabel>
              <select  onChange={(e) => setcat(e.target.value)}>
              <option value="winner 1">Winner</option>
              <option value="winner 2">First Runner Up</option>
              <option value="winner 3">Second Runner Up</option>
              <option value="participant">Participant</option>
              <option value="finalist">Finalist</option>
              <option value="training">Training</option>
              <option value="advisor">Advisor</option>


              </select>
          </IonItem>
          <IonItem>
              <IonLabel>X:</IonLabel>
              <IonInput type='number' onIonChange={(e) => setx(e.target.value)}></IonInput>
          </IonItem>
          <IonItem>
              <IonLabel>Y:</IonLabel>
              <IonInput type='number' onIonChange={e => sety(e.target.value)}></IonInput>
          </IonItem>
          <h3>Font Styling</h3>
          <IonItem>
              <IonLabel>Font Size:</IonLabel>
              <IonInput type='number' onIonChange={e => setSize(e.target.value)}></IonInput>
          </IonItem>
          <IonItem>
              <IonLabel>R:</IonLabel>
              <IonInput type='number' onIonChange={e => setR(e.target.value)} min={0} max={1} step=".01"></IonInput>
          </IonItem>
          <IonItem>
              <IonLabel>G:</IonLabel>
              <IonInput type='number' onIonChange={e => setG(e.target.value)} min={0} max={1} step=".01"></IonInput>
          </IonItem>
          <IonItem>
              <IonLabel>B:</IonLabel>
              <IonInput type='number' onIonChange={e => setB(e.target.value)} min={0} max={1} step=".01"></IonInput>
          </IonItem>
          <IonItem>
            <IonButton onClick={()=>{createcertdetails()}}>Save</IonButton>
          </IonItem>
      </div><div style={{float:"left", marginTop:"40px"}}>
              <iframe src={pdfinfo} style={{

width: "230%",
height: "600px",
              }}/>
          </div>
          {/* <IonButton style={{float:"right", marginTop: "70px"}} onClick={()=>{console.log("test")}}>Add Event</IonButton> */}
          <SuiButton style={{ marginLeft: "60%", marginTop: "120px"}} variant="gradient" color="dark" onClick={()=>{addevent()}}>Add Event</SuiButton>
                    </SuiBox>
                  </Card>
                  <SuiBox mt={4}>{ProjectsPast("Past Events")}</SuiBox>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
